export const START_VIDEO_PLAYER = "VideoPlayer/start";
export const STOP_VIDEO_PLAYER = "VideoPlayer/stop";
